import { EventHandler } from '../sse-resource';

export interface HandlerRef {
  remove(): void;
}
